import React, { Component } from 'react';
import {
    Container
} from 'reactstrap';


export default class Footer extends Component {
    constructor() {
        super();
    }

    render() {
        return (

            <footer>
                <Container>
                    <ul className="horzList">
                        
                        <li><a href="https://www.aig.com/privacy-policy" target="_blank">Privacy Policy</a></li>
                        <li><a href="https://www.aig.com/terms-of-use" target="_blank">Terms Of Use</a></li>
                    </ul>
                    <p>Copyright &copy; {(new Date().getFullYear())}, American International Group, Inc. All rights reserved.</p>
                </Container>

            </footer>
        );
    }
}